import { AgentEventTypes, AgentSource } from '../../api/events-client/events-client.type';
import { icons } from '../../assets/icons/icons';
import { TaskTransition } from '../tasks-table/tasks-table.type';

enum AgentNode {
  USER = 'user',
  AGENT = 'agent',
  TOOLS = 'tools',
}

enum AgenticViewType {
  Tasks = 'tasks',
  Sessions = 'sessions',
  Financials = 'financials',
}

const EVENT_TYPES_LABELS: Record<AgentEventTypes, string> = {
  [AgentEventTypes.LLM_START]: 'LLM Start',
  [AgentEventTypes.LLM_END]: 'LLM End',
  [AgentEventTypes.THINKING_START]: 'Thinking Start',
  [AgentEventTypes.THINKING_END]: 'Thinking End',
  [AgentEventTypes.PLANNING_START]: 'Planning Start',
  [AgentEventTypes.PLANNING_END]: 'Planning End',
  [AgentEventTypes.AGENT_CALL]: 'Agent Call',
  [AgentEventTypes.AGENT_RESULT]: 'Agent Result',
  [AgentEventTypes.AGENT_ERROR]: 'Agent Error',
  [AgentEventTypes.TOOL_CALL]: 'Tool Call',
  [AgentEventTypes.TOOL_RESULT]: 'Tool Result',
  [AgentEventTypes.TOOL_ERROR]: 'Tool Error',
  [AgentEventTypes.USER_PROMPT]: 'User Prompt',
  [AgentEventTypes.HUMAN_INPUT_REQUESTED]: 'Human Input Requested',
  [AgentEventTypes.HUMAN_INPUT_RECEIVED]: 'Human Input Received',
  [AgentEventTypes.UNKNOWN]: 'Unknown',
};

const AGENT_SOURCES_LABELS: Record<AgentSource, string> = {
  [AgentSource.CURSOR]: 'Cursor',
  [AgentSource.CURSOR_CLI]: 'Cursor CLI',
  [AgentSource.WINDSURF]: 'Windsurf',
  [AgentSource.CHATGPT]: 'ChatGPT',
  [AgentSource.CHATGPT_DESKTOP]: 'ChatGPT Desktop',
  [AgentSource.CODEX]: 'Codex',
  [AgentSource.CLAUDE]: 'Claude',
  [AgentSource.CLAUDE_DESKTOP]: 'Claude Desktop',
  [AgentSource.CLAUDE_CODE]: 'Claude Code',
  [AgentSource.VS_CODE]: 'VS Code',
  [AgentSource.COPILOT]: 'Copilot',
  [AgentSource.UNKNOWN]: 'Unknown',
};

const AGENT_SOURCES_ICONS: Record<AgentSource, string | undefined> = {
  [AgentSource.CURSOR]: icons.iconCursor,
  [AgentSource.CURSOR_CLI]: icons.iconCursor,
  [AgentSource.WINDSURF]: icons.iconWindsurf,
  [AgentSource.CHATGPT]: icons.iconOpenAI,
  [AgentSource.CHATGPT_DESKTOP]: icons.iconOpenAI,
  [AgentSource.CODEX]: icons.iconCodex,
  [AgentSource.CLAUDE]: icons.iconClaude,
  [AgentSource.CLAUDE_DESKTOP]: icons.iconClaude,
  [AgentSource.CLAUDE_CODE]: icons.iconClaude,
  [AgentSource.VS_CODE]: icons.iconVSCode,
  [AgentSource.COPILOT]: icons.iconGithubCopilot,
  [AgentSource.UNKNOWN]: undefined,
};

const AGENT_SOURCES_WORDMARKS: Record<AgentSource, string | undefined> = {
  [AgentSource.CURSOR]: icons.iconCursorWordmark,
  [AgentSource.CURSOR_CLI]: icons.iconCursorWordmark,
  [AgentSource.WINDSURF]: undefined,
  [AgentSource.CHATGPT]: icons.iconOpenAIWordmark,
  [AgentSource.CHATGPT_DESKTOP]: icons.iconOpenAIWordmark,
  [AgentSource.CODEX]: icons.iconCodexWordmark,
  [AgentSource.CLAUDE]: icons.iconClaudeWordmark,
  [AgentSource.CLAUDE_DESKTOP]: icons.iconClaudeWordmark,
  [AgentSource.CLAUDE_CODE]: icons.iconClaudeWordmark,
  [AgentSource.VS_CODE]: undefined,
  [AgentSource.COPILOT]: undefined,
  [AgentSource.UNKNOWN]: undefined,
};

type SessionMetadata = {
  sessionId: string;
  isCollapsed: boolean;
  agentSource: AgentSource;
  startDate: string;
  endDate: string;
  startY: number;
  endY: number;
  userPromptCount: number;
  toolCallCount: number;
};

type TaskStatusPeriod = {
  status: string;
  startTime: string;
  endTime: string | null; // null means it's the current status (ongoing)
  transition: TaskTransition;
  isCurrentStatus: boolean;
};

export {
  AGENT_SOURCES_ICONS,
  AGENT_SOURCES_LABELS,
  AGENT_SOURCES_WORDMARKS,
  AgenticViewType,
  AgentNode,
  EVENT_TYPES_LABELS,
};
export type { SessionMetadata, TaskStatusPeriod };
